<i18n lang='yml' src='./LogbooksWidget.yml'></i18n>
<template>
  <div class="col-md-6 col-lg-4">
    <div class="alert alert-danger" role="alert" v-if="error">
      {{$t('loading_error') }}
    </div>
    <div class="col-trans-right white-bg">
      <div class="layout-tile">
        <h4 class="heading-block d-flex mb-0">
          {{ title }}
        </h4>
        <div class="content-block content-block-widgets">
          <div class="post-view">
            <ul class="post-content"  >
              <li class="view-area" v-for="link in linksList" :key="link.href">
                <a :href="link.href">{{link.title}}</a>
              </li> 
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  props: ['locale', 'links', 'title'],
  data() {
    return {
      linksList: [],
      error: false
    }
  },
  mounted() {
    try {
      this.linksList = JSON.parse(this.links) || [];
    }
    catch(err) {
      console.log(this.err)
      this.error = true
    }
  },

}
</script>
